
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire48bd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire48bd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
//src\js\cases-desktop.jquery.js

var $aaQnt = parcelRequire("aaQnt");
// Функция для проверки ширины экрана
const $95c947e998ff2a48$var$isDesktopWidth = ()=>{
    return window.matchMedia('(min-width: 768px)').matches;
};
const $95c947e998ff2a48$var$addOddClass = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.card-image-pc-container').odd().addClass('is-odd');
};
const $95c947e998ff2a48$var$closeDescription = ($element)=>{
    $95c947e998ff2a48$var$animateDescriptionToggle($element, ()=>{
        $element.addClass('is-hidden');
    });
};
const $95c947e998ff2a48$var$isRightAlignedCard = ($card)=>{
    return $card.hasClass("is-odd");
};
const $95c947e998ff2a48$var$handleWideCardClick = function($card) {
    const $description = $card.find('.case-description-container');
    const $previousDescription = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.case-description-container:not(.is-hidden)');
    const isRightAligned = $95c947e998ff2a48$var$isRightAlignedCard($card);
    // Закрытие предыдущего открытого описания
    $95c947e998ff2a48$var$closeDescription($previousDescription);
    // Открытие текущего описания
    if ($description.hasClass('is-hidden')) {
        // Центрирование описания
        if (isRightAligned) $description.css('transform', 'translateX(-26vw)');
        else $description.css('transform', 'translateX(0)');
        $95c947e998ff2a48$var$animateDescriptionToggle($description, ()=>{
            $description.removeClass('is-hidden');
        });
    }
};
const $95c947e998ff2a48$var$handleNarrowCardClick = function($card) {
    const $description = $card.find('.case-description-container');
    const $previousDescription = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.case-description-container:not(.is-hidden)').not($description);
    const $siblingCard = $card.siblings('.card-image-pc-container').not($card);
    const isRightAligned = $95c947e998ff2a48$var$isRightAlignedCard($card);
    // Закрытие предыдущего открытого описания
    $95c947e998ff2a48$var$closeDescription($previousDescription);
    $95c947e998ff2a48$var$animateCardExpansion($card, $siblingCard, ()=>{
        $card.removeClass('narrow-image').addClass('wide-image');
        $siblingCard.removeClass('wide-image').addClass('narrow-image');
        console.log(isRightAligned);
        // Центрирование описания
        if (isRightAligned) $description.css('transform', 'translateX(-26vw)');
        else $description.css('transform', 'translateX(0)');
        $95c947e998ff2a48$var$animateDescriptionToggle($description, ()=>{
            $description.removeClass('is-hidden');
        });
    });
};
const $95c947e998ff2a48$var$animateCardExpansion = function($card, $siblingCard, complete = ()=>{}) {
    const cardWidth = $card.outerWidth();
    const siblingWidth = $siblingCard.outerWidth();
    $card.animate({
        width: cardWidth + siblingWidth
    }, {
        duration: 500
    });
    $siblingCard.animate({
        width: 0
    }, {
        duration: 500,
        complete: complete
    });
};
const $95c947e998ff2a48$var$animateDescriptionToggle = function($description, complete = ()=>{}) {
    $description.animate({
        height: 'toggle',
        opacity: 'toggle'
    }, {
        duration: 500,
        complete: complete
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(document).ready(function() {
    if (!$95c947e998ff2a48$var$isDesktopWidth()) return;
    $95c947e998ff2a48$var$addOddClass();
    (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))('.case-card-pc-module').on('click', '.card-image-pc-container', function() {
        const $card = (0, (/*@__PURE__*/$parcel$interopDefault($aaQnt)))(this);
        if ($card.hasClass('wide-image')) $95c947e998ff2a48$var$handleWideCardClick($card);
        else $95c947e998ff2a48$var$handleNarrowCardClick($card);
    });
});


//# sourceMappingURL=cases.6963a177.js.map
